export const getCountries = () => {
    return [
        { value: 8, label: 'ALBANIA' },
        { value: 276, label: 'ALEMANIA' },
        { value: 20, label: 'ANDORRA' },
        { value: 24, label: 'ANGOLA' },
        { value: 660, label: 'ANGUILLA' },
        { value: 28, label: 'ANTIGUA Y BARBUDA' },
        { value: 530, label: 'ANTILLAS HOLANDESAS' },
        { value: 682, label: 'ARABIA SAUDITA' },
        { value: 12, label: 'ARGELIA' },
        { value: 32, label: 'ARGENTINA' },
        { value: 51, label: 'ARMENIA' },
        { value: 533, label: 'ARUBA' },
        { value: 36, label: 'AUSTRALIA' },
        { value: 40, label: 'AUSTRIA' },
        { value: 31, label: 'AZERBAIJAN' },
        { value: 44, label: 'BAHAMAS' },
        { value: 48, label: 'BAHREIN' },
        { value: 50, label: 'BANGLADESH' },
        { value: 52, label: 'BARBADOS' },
        { value: 56, label: 'BELGICA' },
        { value: 21, label: 'BELICE' },
        { value: 23, label: 'BERMUDAS' },
        { value: 112, label: 'BIELORRUSIA' },
        { value: 68, label: 'BOLIVIA' },
        { value: 70, label: 'BOSNIA-HERZEGOVINA' },
        { value: 72, label: 'BOTSWANA' },
        { value: 76, label: 'BRASIL' },
        { value: 96, label: 'BRUNEI DARUSSALAM' },
        { value: 100, label: 'BULGARIA' },
        { value: 854, label: 'BURKINA FASO' },
        { value: 108, label: 'BURUNDI' },
        { value: 64, label: 'BUTAN' },
        { value: 2, label: 'CABO VERDE' },
        { value: 37, label: 'CAMBOYA' },
        { value: 120, label: 'CAMERUN' },
        { value: 124, label: 'CANADA' },
        { value: 148, label: 'CHAD' },
        { value: 152, label: 'CHILE' },
        { value: 156, label: 'CHINA' },
        { value: 196, label: 'CHIPRE' },
        { value: 170, label: 'COLOMBIA' },
        { value: 174, label: 'COMORAS' },
        { value: 178, label: 'CONGO' },
        { value: 180, label: 'CONGO ex Zaire' },
        { value: 408, label: 'COREA DEL NORTE' },
        { value: 410, label: 'COREA DEL SUR' },
        { value: 384, label: 'COSTA DE MARFIL' },
        { value: 188, label: 'COSTA RICA' },
        { value: 191, label: 'CROACIA' },
        { value: 192, label: 'CUBA' },
        { value: 531, label: 'CURACAO' },
        { value: 204, label: 'DAHOMEY BENIN' },
        { value: 208, label: 'DINAMARCA' },
        { value: 212, label: 'DOMINICA' },
        { value: 218, label: 'ECUADOR' },
        { value: 840, label: 'EEUU' },
        { value: 818, label: 'EGIPTO' },
        { value: 222, label: 'EL SALVADOR' },
        { value: 255, label: 'EL VATICANO' },
        { value: 220, label: 'EMIRATOS ARABES' },
        { value: 232, label: 'ERITREA' },
        { value: 703, label: 'ESLOVAQUIA' },
        { value: 705, label: 'ESLOVENIA' },
        { value: 724, label: 'ESPANA' },
        { value: 233, label: 'ESTONIA' },
        { value: 231, label: 'ETIOPIA' },
        { value: 608, label: 'FILIPINAS' },
        { value: 246, label: 'FINLANDIA' },
        { value: 250, label: 'FRANCIA' },
        { value: 266, label: 'GABON' },
        { value: 83, label: 'GEORGIA' },
        { value: 84, label: 'GHANA' },
        { value: 292, label: 'GIBRALTAR' },
        { value: 300, label: 'GRECIA' },
        { value: 304, label: 'GROENLANDIA' },
        { value: 312, label: 'GUADALUPE' },
        { value: 320, label: 'GUATEMALA' },
        { value: 831, label: 'GUERNSEY' },
        { value: 324, label: 'GUINEA' },
        { value: 624, label: 'GUINEA BISSAU' },
        { value: 226, label: 'GUINEA ECUATORIAL' },
        { value: 901, label: 'GUYANA' },
        { value: 332, label: 'HAITI' },
        { value: 528, label: 'HOLANDA' },
        { value: 340, label: 'HONDURAS' },
        { value: 344, label: 'HONG KONG' },
        { value: 348, label: 'HUNGRIA' },
        { value: 356, label: 'INDIA' },
        { value: 360, label: 'INDONESIA' },
        { value: 368, label: 'IRAK' },
        { value: 364, label: 'IRAN' },
        { value: 372, label: 'IRLANDA' },
        { value: 3, label: 'ISLA DE MAN' },
        { value: 638, label: 'ISLA REUNION' },
        { value: 352, label: 'ISLANDIA' },
        { value: 136, label: 'ISLAS CAYMAN' },
        { value: 184, label: 'ISLAS COOK' },
        { value: 90, label: 'ISLAS SALOMON' },
        { value: 796, label: 'ISLAS TURKS Y CAICOS' },
        { value: 850, label: 'ISLAS VIRG AMERIC' },
        { value: 92, label: 'ISLAS VIRG BRIT' },
        { value: 376, label: 'ISRAEL' },
        { value: 380, label: 'ITALIA' },
        { value: 388, label: 'JAMAICA' },
        { value: 392, label: 'JAPON' },
        { value: 1, label: 'JERSEY, C.I.' },
        { value: 110, label: 'JORDAN' },
        { value: 398, label: 'KAZAKISTAN' },
        { value: 404, label: 'KENIA' },
        { value: 296, label: 'KIRIBATI' },
        { value: 900, label: 'KOSOVO' },
        { value: 414, label: 'KUWAIT' },
        { value: 417, label: 'KYRGYZSTAN' },
        { value: 418, label: 'LAOS' },
        { value: 428, label: 'LETONIA' },
        { value: 422, label: 'LIBANO' },
        { value: 430, label: 'LIBERIA' },
        { value: 434, label: 'LIBIA' },
        { value: 438, label: 'LIECHTENSTEIN' },
        { value: 440, label: 'LITUANIA' },
        { value: 442, label: 'LUXEMBURGO' },
        { value: 446, label: 'MACAO' },
        { value: 807, label: 'MACEDONIA (ARYM)' },
        { value: 450, label: 'MADAGASCAR' },
        { value: 458, label: 'MALASIA' },
        { value: 462, label: 'MALDIVAS' },
        { value: 470, label: 'MALTA' },
        { value: 504, label: 'MARRUECOS' },
        { value: 480, label: 'MAURICIO' },
        { value: 478, label: 'MAURITANIA' },
        { value: 484, label: 'MEXICO' },
        { value: 583, label: 'MICRONESIA' },
        { value: 492, label: 'MONACO' },
        { value: 499, label: 'MONTENEGRO' },
        { value: 500, label: 'MONTSERRAT' },
        { value: 143, label: 'MOZAMBIQUE' },
        { value: 104, label: 'MYANMAR' },
        { value: 516, label: 'NAMIBIA' },
        { value: 524, label: 'NEPAL' },
        { value: 558, label: 'NICARAGUA' },
        { value: 562, label: 'NIGER' },
        { value: 566, label: 'NIGERIA' },
        { value: 570, label: 'NIVE' },
        { value: 758, label: 'NORUEGA' },
        { value: 554, label: 'NUEVA ZELANDA' },
        { value: 512, label: 'OMAN' },
        { value: 586, label: 'PAKISTAN' },
        { value: 585, label: 'PALAU' },
        { value: 275, label: 'PALESTINA' },
        { value: 590, label: 'PANAMA' },
        { value: 598, label: 'PAPUA NUEVA GUINEA' },
        { value: 600, label: 'PARAGUAY' },
        { value: 604, label: 'PERU' },
        { value: 616, label: 'POLONIA' },
        { value: 620, label: 'PORTUGAL' },
        { value: 630, label: 'PUERTO RICO' },
        { value: 634, label: 'QATAR' },
        { value: 826, label: 'REINO UNIDO' },
        { value: 140, label: 'REP. CENTROAFRICANA' },
        { value: 203, label: 'REPUBLICA CHECA' },
        { value: 214, label: 'REPUBLICA DOMINICANA' },
        { value: 646, label: 'RUANDA' },
        { value: 642, label: 'RUMANIA' },
        { value: 643, label: 'RUSIA' },
        { value: 732, label: 'SAHARA ESPA?OL' },
        { value: 882, label: 'SAMOA' },
        { value: 902, label: 'SAN CRISTOBAL Y NIEV' },
        { value: 181, label: 'SAN MARINO' },
        { value: 670, label: 'SAN VICENTEYLAS GRAN' },
        { value: 662, label: 'SANTA LUCIA' },
        { value: 221, label: 'SENEGAL' },
        { value: 688, label: 'SERBIA' },
        { value: 891, label: 'SERBIA Y MONTENEGRO' },
        { value: 690, label: 'SEYCHELLES' },
        { value: 186, label: 'SIERRA LEONA' },
        { value: 0, label: 'SIN IDENTIFICAR' },
        { value: 702, label: 'SINGAPUR' },
        { value: 760, label: 'SIRIA' },
        { value: 706, label: 'SOMALIA' },
        { value: 144, label: 'SRI LANKA' },
        { value: 678, label: 'STO.TOME Y PRINCIPE' },
        { value: 710, label: 'SUDAFRICA' },
        { value: 736, label: 'SUDAN' },
        { value: 752, label: 'SUECIA' },
        { value: 756, label: 'SUIZA' },
        { value: 740, label: 'SURINAM' },
        { value: 748, label: 'SWAZILANDIA' },
        { value: 764, label: 'TAILANDIA' },
        { value: 158, label: 'TAIWAN' },
        { value: 762, label: 'TAJIKISTAN' },
        { value: 834, label: 'TANZANIA' },
        { value: 86, label: 'TERR BRIT O INDICO' },
        { value: 626, label: 'TIMOR ORIENTAL' },
        { value: 780, label: 'TRINIDAD Y TOBADO' },
        { value: 788, label: 'TUNEZ' },
        { value: 795, label: 'TURKMENISTAN' },
        { value: 792, label: 'TURQUIA' },
        { value: 798, label: 'TUVALU' },
        { value: 804, label: 'UCRANIA' },
        { value: 800, label: 'UGANDA' },
        { value: 858, label: 'URUGUAY' },
        { value: 860, label: 'UZBEKISTAN' },
        { value: 548, label: 'VANUATU' },
        { value: 862, label: 'VENEZUELA' },
        { value: 704, label: 'VIETNAM' },
        { value: 876, label: 'WALLIS AND FUTUNA IS' },
        { value: 887, label: 'YEMEN' },
        { value: 262, label: 'YIBUTI' },
        { value: 716, label: 'ZIMBABWE' },
    ];
}

export const getNationalities = () => {
    return [
        { value: 'AFGANISTAN', label: 'AFGANISTAN' },
        { value: 'ALBANES', label: 'ALBANES' },
        { value: 'ALEMAN', label: 'ALEMAN' },
        { value: 'AMERICANA', label: 'AMERICANA' },
        { value: 'ANDORRANO', label: 'ANDORRANO' },
        { value: 'ANGOLANO', label: 'ANGOLANO' },
        { value: 'ANGUILLA', label: 'ANGUILLA' },
        { value: 'ANTIGUANO', label: 'ANTIGUANO' },
        { value: 'ANTILLANO', label: 'ANTILLANO' },
        { value: 'ARABE', label: 'ARABE' },
        { value: 'ARGELINO', label: 'ARGELINO' },
        { value: 'ARGENTINO', label: 'ARGENTINO' },
        { value: 'ARMENIO', label: 'ARMENIO' },
        { value: 'ARUBA', label: 'ARUBA' },
        { value: 'AUSTRALIANO', label: 'AUSTRALIANO' },
        { value: 'AUSTRIACO', label: 'AUSTRIACO' },
        { value: 'AZERBAIJANO', label: 'AZERBAIJANO' },
        { value: 'BAHAMES', label: 'BAHAMES' },
        { value: 'BAHREINÍ.', label: 'BAHREIN&#205;.' },
        { value: 'BARBADOS', label: 'BARBADOS' },
        { value: 'BELGA', label: 'BELGA' },
        { value: 'BELICEÑO', label: 'BELICE&#209;O' },
        { value: 'BENGALÍ.', label: 'BENGAL&#205;.' },
        { value: 'BERMUDAS', label: 'BERMUDAS' },
        { value: 'BIELORRUSO', label: 'BIELORRUSO' },
        { value: 'BIRMANO', label: 'BIRMANO' },
        { value: 'BOLIVIANO', label: 'BOLIVIANO' },
        { value: 'BOSNIOHERZEGOVINO', label: 'BOSNIOHERZEGOVINO' },
        { value: 'BOTSUANA', label: 'BOTSUANA' },
        { value: 'BRASILEÑO', label: 'BRASILE&#209;O' },
        { value: 'BRUNEANO/-A', label: 'BRUNEANO/-A' },
        { value: 'BULGARO', label: 'BULGARO' },
        { value: 'BURKINESA', label: 'BURKINESA' },
        { value: 'BURUNDES', label: 'BURUNDES' },
        { value: 'BUTANES', label: 'BUTANES' },
        { value: 'CABO VERVE', label: 'CABO VERVE' },
        { value: 'CALPENSE', label: 'CALPENSE' },
        { value: 'CAMBOYANO', label: 'CAMBOYANO' },
        { value: 'CAMERUNES', label: 'CAMERUNES' },
        { value: 'CANADIENSE', label: 'CANADIENSE' },
        { value: 'CAYMANES', label: 'CAYMANES' },
        { value: 'CENTROAFRICANO', label: 'CENTROAFRICANO' },
        { value: 'CHADIANO', label: 'CHADIANO' },
        { value: 'CHECO', label: 'CHECO' },
        { value: 'CHILENO', label: 'CHILENO' },
        { value: 'CHINO', label: 'CHINO' },
        { value: 'CHIPRIOTA', label: 'CHIPRIOTA' },
        { value: 'CINGALES', label: 'CINGALES' },
        { value: 'COLOMBIANO', label: 'COLOMBIANO' },
        { value: 'COMORANO', label: 'COMORANO' },
        { value: 'CONGOLEÑO', label: 'CONGOLE&#209;O' },
        { value: 'CONGOLEÑO', label: 'CONGOLE&#209;O' },
        { value: 'COREANO', label: 'COREANO' },
        { value: 'COREANO', label: 'COREANO' },
        { value: 'COSTARICENSE', label: 'COSTARICENSE' },
        { value: 'CROATA', label: 'CROATA' },
        { value: 'CUBANO', label: 'CUBANO' },
        { value: 'CURAZOLEÑO', label: 'CURAZOLE&#209;O' },
        { value: 'DAHOMEY BENIN', label: 'DAHOMEY BENIN' },
        { value: 'DANES', label: 'DANES' },
        { value: 'DOMINICANO', label: 'DOMINICANO' },
        { value: 'DOMINIQUES', label: 'DOMINIQUES' },
        { value: 'ECUATOGUINEANO', label: 'ECUATOGUINEANO' },
        { value: 'ECUATORIANO', label: 'ECUATORIANO' },
        { value: 'EGIPCIO', label: 'EGIPCIO' },
        { value: 'ERITREO', label: 'ERITREO' },
        { value: 'ESLOVACO', label: 'ESLOVACO' },
        { value: 'ESLOVENO', label: 'ESLOVENO' },
        { value: 'ESPAÑOL', label: 'ESPA&#209;OL' },
        { value: 'ESTADOUNIDENSE', label: 'ESTADOUNIDENSE' },
        { value: 'ESTONIO', label: 'ESTONIO' },
        { value: 'ETIOPE', label: 'ETIOPE' },
        { value: 'FILIPINO', label: 'FILIPINO' },
        { value: 'FINLANDES', label: 'FINLANDES' },
        { value: 'FRANCES', label: 'FRANCES' },
        { value: 'GABONES', label: 'GABONES' },
        { value: 'GEORGIA', label: 'GEORGIA' },
        { value: 'GHANES', label: 'GHANES' },
        { value: 'GRIEGO', label: 'GRIEGO' },
        { value: 'GROENLANDIA', label: 'GROENLANDIA' },
        { value: 'GUADALUPENSE', label: 'GUADALUPENSE' },
        { value: 'GUATEMALTECO', label: 'GUATEMALTECO' },
        { value: 'GUERNSEY', label: 'GUERNSEY' },
        { value: 'GUINEANA', label: 'GUINEANA' },
        { value: 'GUINEANA', label: 'GUINEANA' },
        { value: 'GUYANESA', label: 'GUYANESA' },
        { value: 'HAITIANO', label: 'HAITIANO' },
        { value: 'HOLANDES', label: 'HOLANDES' },
        { value: 'HONDUREÑO', label: 'HONDURE&#209;O' },
        { value: 'HONGKONÉS', label: 'HONGKON&#201;S' },
        { value: 'HUNGARO', label: 'HUNGARO' },
        { value: 'INDIO', label: 'INDIO' },
        { value: 'INDONESIO', label: 'INDONESIO' },
        { value: 'INGLES', label: 'INGLES' },
        { value: 'IRANI', label: 'IRANI' },
        { value: 'IRAQUI', label: 'IRAQUI' },
        { value: 'IRLANDES', label: 'IRLANDES' },
        { value: 'ISLA DE MAN', label: 'ISLA DE MAN' },
        { value: 'ISLA REUNION', label: 'ISLA REUNION' },
        { value: 'ISLANDES', label: 'ISLANDES' },
        { value: 'ISLAS COOK', label: 'ISLAS COOK' },
        { value: 'ISLAS TURKS Y CAICOS', label: 'ISLAS TURKS Y CAICOS' },
        { value: 'ISLAS VIRG BRIT', label: 'ISLAS VIRG BRIT' },
        { value: 'ISRAELITA', label: 'ISRAELITA' },
        { value: 'ITALIANO', label: 'ITALIANO' },
        { value: 'JAMAIQUINO', label: 'JAMAIQUINO' },
        { value: 'JAPONES', label: 'JAPONES' },
        { value: 'JERSEY', label: 'JERSEY' },
        { value: 'JORDANO', label: 'JORDANO' },
        { value: 'KAZAKISTAN', label: 'KAZAKISTAN' },
        { value: 'KENIATA', label: 'KENIATA' },
        { value: 'KIRIBATIANO', label: 'KIRIBATIANO' },
        { value: 'KOSOVAR', label: 'KOSOVAR' },
        { value: 'KUWAITÍ', label: 'KUWAIT&#205;' },
        { value: 'LAOSIANO', label: 'LAOSIANO' },
        { value: 'LETÓN', label: 'LET&#211;N' },
        { value: 'LIBANES', label: 'LIBANES' },
        { value: 'LIBERIANO', label: 'LIBERIANO' },
        { value: 'LIBIO', label: 'LIBIO' },
        { value: 'LIECHTENSTEINIANO', label: 'LIECHTENSTEINIANO' },
        { value: 'LITANO', label: 'LITANO' },
        { value: 'LUXEMBURGuES', label: 'LUXEMBURGuES' },
        { value: 'MACAENSE', label: 'MACAENSE' },
        { value: 'MACEDONIO', label: 'MACEDONIO' },
        { value: 'MALAYO', label: 'MALAYO' },
        { value: 'MALDIVO', label: 'MALDIVO' },
        { value: 'MALGACHE', label: 'MALGACHE' },
        { value: 'MALTES', label: 'MALTES' },
        { value: 'MARFILEÑO', label: 'MARFILE&#209;O' },
        { value: 'MARROQUI', label: 'MARROQUI' },
        { value: 'MAURICINAO', label: 'MAURICINAO' },
        { value: 'MAURITANO', label: 'MAURITANO' },
        { value: 'MEXICANO', label: 'MEXICANO' },
        { value: 'MICRONESIO', label: 'MICRONESIO' },
        { value: 'MONEGASCO', label: 'MONEGASCO' },
        { value: 'MONTENEGRINO', label: 'MONTENEGRINO' },
        { value: 'MONTSERRAT', label: 'MONTSERRAT' },
        { value: 'MOZAMBIQUE', label: 'MOZAMBIQUE' },
        { value: 'NAMIBIO', label: 'NAMIBIO' },
        { value: 'NEOZELANDES', label: 'NEOZELANDES' },
        { value: 'NEPALI', label: 'NEPALI' },
        { value: 'NICARAGUENSE', label: 'NICARAGUENSE' },
        { value: 'NIGERIANO', label: 'NIGERIANO' },
        { value: 'NIGERINO', label: 'NIGERINO' },
        { value: 'NIVEÑO', label: 'NIVE&#209;O' },
        { value: 'NORUEGO', label: 'NORUEGO' },
        { value: 'OMANI', label: 'OMANI' },
        { value: 'PAKISTANÍ', label: 'PAKISTAN&#205;' },
        { value: 'PALAU', label: 'PALAU' },
        { value: 'PALESTINO', label: 'PALESTINO' },
        { value: 'PANAMEÑO', label: 'PANAME&#209;O' },
        { value: 'PAPUANO', label: 'PAPUANO' },
        { value: 'PARAGUAYO', label: 'PARAGUAYO' },
        { value: 'PERUANO', label: 'PERUANO' },
        { value: 'POLACO', label: 'POLACO' },
        { value: 'PORTUGUES', label: 'PORTUGUES' },
        { value: 'PUERTORIQUEÑO', label: 'PUERTORIQUE&#209;O' },
        { value: 'QATARÍ', label: 'QATAR&#205;' },
        { value: 'RUANDES', label: 'RUANDES' },
        { value: 'RUMANO', label: 'RUMANO' },
        { value: 'RUSA', label: 'RUSA' },
        { value: 'RUSO', label: 'RUSO' },
        { value: 'SAHARA ESPA?OL', label: 'SAHARA ESPA?OL' },
        { value: 'SALOMONENSE', label: 'SALOMONENSE' },
        { value: 'SALVADOREÑO', label: 'SALVADORE&#209;O' },
        { value: 'SAMOA', label: 'SAMOA' },
        { value: 'SAN CRISTOBAL', label: 'SAN CRISTOBAL' },
        { value: 'SAN MARINO', label: 'SAN MARINO' },
        { value: 'SANTALUCENSE', label: 'SANTALUCENSE' },
        { value: 'SANTOTOMENSE', label: 'SANTOTOMENSE' },
        { value: 'SANVICENTINO', label: 'SANVICENTINO' },
        { value: 'SAUDITA', label: 'SAUDITA' },
        { value: 'SENEGALES', label: 'SENEGALES' },
        { value: 'SERBIO', label: 'SERBIO' },
        { value: 'SERBIO', label: 'SERBIO' },
        { value: 'SEYCHELLES', label: 'SEYCHELLES' },
        { value: 'SIERRA LEONA', label: 'SIERRA LEONA' },
        { value: 'SIN IDENTIFICAR', label: 'SIN IDENTIFICAR' },
        { value: 'SINGAPURENSE', label: 'SINGAPURENSE' },
        { value: 'SIRIO', label: 'SIRIO' },
        { value: 'SOMALI', label: 'SOMALI' },
        { value: 'SUAZI', label: 'SUAZI' },
        { value: 'SUDAFRICANO', label: 'SUDAFRICANO' },
        { value: 'SUDANES', label: 'SUDANES' },
        { value: 'SUECO', label: 'SUECO' },
        { value: 'SUIZO', label: 'SUIZO' },
        { value: 'SURINAM', label: 'SURINAM' },
        { value: 'TAILANDES', label: 'TAILANDES' },
        { value: 'TAIWANES', label: 'TAIWANES' },
        { value: 'TAJIKO', label: 'TAJIKO' },
        { value: 'TANZANIA', label: 'TANZANIA' },
        { value: 'TIMORENSE', label: 'TIMORENSE' },
        { value: 'TRINITENSE', label: 'TRINITENSE' },
        { value: 'TUNECINO', label: 'TUNECINO' },
        { value: 'TURCO', label: 'TURCO' },
        { value: 'TURCOMANO', label: 'TURCOMANO' },
        { value: 'TUVALUANO', label: 'TUVALUANO' },
        { value: 'UCRANIANO', label: 'UCRANIANO' },
        { value: 'UGANDESA', label: 'UGANDESA' },
        { value: 'URUGUAYO', label: 'URUGUAYO' },
        { value: 'UZBEKO', label: 'UZBEKO' },
        { value: 'VANUATUENSE', label: 'VANUATUENSE' },
        { value: 'VATICANO', label: 'VATICANO' },
        { value: 'VENEZOLANO', label: 'VENEZOLANO' },
        { value: 'VIETNAMITA', label: 'VIETNAMITA' },
        { value: 'WALLIS AND FUTUNA IS', label: 'WALLIS AND FUTUNA IS' },
        { value: 'YEMENIES', label: 'YEMENIES' },
        { value: 'YIBUTIANO', label: 'YIBUTIANO' },
        { value: 'ZIMBABWE', label: 'ZIMBABWE' },
    ];
}

export const getStates = () => {
    return [
        { value: '1', label: 'MONTEVIDEO' },
        { value: '2', label: 'ARTIGAS' },
        { value: '3', label: 'CANELONES' },
        { value: '4', label: 'CERRO LARGO' },
        { value: '5', label: 'COLONIA' },
        { value: '6', label: 'DURAZNO' },
        { value: '7', label: 'FLORES' },
        { value: '8', label: 'FLORIDA' },
        { value: '9', label: 'LAVALLEJA' },
        { value: '10', label: 'MALDONADO' },
        { value: '11', label: 'PAYSANDU' },
        { value: '12', label: 'RIO NEGRO' },
        { value: '13', label: 'RIVERA' },
        { value: '14', label: 'ROCHA' },
        { value: '15', label: 'SALTO' },
        { value: '16', label: 'SAN JOSE' },
        { value: '17', label: 'SORIANO' },
        { value: '18', label: 'TACUAREMBO' },
        { value: '19', label: 'TREINTA Y TRES' }
    ];
}

export const getOffices = () => {
    return [
        { value: '48', label: 'ARTIGAS' },
        { value: '22', label: 'CARMELO' },
        { value: '91', label: 'CARRASCO' },
        { value: '1', label: 'CASA CENTRAL' },
        { value: '52', label: 'COLON' },
        { value: '53', label: 'COLONIA' },
        { value: '3', label: 'CORDON' },
        { value: '18', label: 'DURAZNO' },
        { value: '41', label: 'FLORIDA' },
        { value: '6', label: 'MELO' },
        { value: '2', label: 'MERCADO AGRICOLA' },
        { value: '7', label: 'MERCEDES' },
        { value: '11', label: 'MINAS' },
        { value: '26', label: 'NUEVOCENTRO' },
        { value: '19', label: 'P. DEL ESTE' },
        { value: '8', label: 'PAYSANDU' },
        { value: '29', label: 'POCITOS' },
        { value: '54', label: 'POLICLINICO' },
        { value: '88', label: 'PUNTA CARRETAS' },
        { value: '44', label: 'RIVERA' },
        { value: '47', label: 'ROCHA' },
        { value: '58', label: 'ROOSEVELT' },
        { value: '9', label: 'SALTO' },
        { value: '51', label: 'SAN JOSE' },
        { value: '10', label: 'TACUAREMBO' },
        { value: '35', label: 'TREINTA Y TRES' },
        { value: '25', label: 'TRES CRUCES' },
        { value: '34', label: 'TRINIDAD' },
        { value: '24', label: 'WTC' }
    ];
}

export const getMarketRates = () => {    
    return [
        { value: '1', label: '$' },
        { value: '2222', label: 'U$S' }
    ]
} 